export const inspectTable = [
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제4조 제3호',
      '유해·위험요인 확인·개선 절차마련(반기1회 점검)',
      '위험성평가 실시 및 위험성 감소대책 시행 (연1회)',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제4조 제8호',
      '중대산업재해 및 위험대비 매뉴얼',
      '급박한 위험(산업재해 발생) 대비 매뉴얼 상황별) 마련 및 조치',
      '전 부서(동)',
    ],
    isChecked: ``,
  },

  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '부서(동)별 산재예방계획 수립',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '안전·보건 관리규정 게시',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '물질안전보건자료\n- 화학물질 보유 현황 목록화',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '물질안전보건자료\n- 물질안전보건자료 게시',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '물질안전보건자료\n- 물질안전보건자료 교육',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '건강진단 \n' +
      '- 일반건강진단 실시',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '건강진단 \n' +
      '- 특수건강진단 실시',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '보호구 \n' +
      '- 보호구 지급 및 착용 점검',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '보호구 \n' +
      '- 보호구 관리 대장 작성 여부',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '작업환경측정 \n' +
      '- 작업환경측정 실시',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '작업환경측정 \n' +
      '- 측정결과 종사자에게 공지',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '작업환경측정 \n' +
      '- 작업환경 개선조치',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '근골격계 부담작업\n' +
      '- 근골격계유해요인조사 실시',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '근골격계 부담작업\n' +
      '- 근골격계 부담작업 유해 요인 조사 결과 개선조치',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '밀폐공간\n' +
      '- 밀폐공간 작업 프로그램 수립',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '밀폐공간\n' +
      '- 밀폐공간 작업 프로그램 실시',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '유해·위험요인개선 등 안전보건 예산 \n' +
      '편성 및 집행',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '작업계획서 작성 및 작업지휘자 지정\n' +
      '(차량계 하역운반기계, 중량물 취급작업 등)',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '유해위험기계·기구 관리 안전검사 실시\n' +
      '<span style="color: #4839EB;\n">해당 있는 부서는 (대상기계기구 보유현황 및 점검일지, 안전검사필증(사진), 검사주기 등 </span>',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '안전보건 표지설치',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '법령요지 등 게시',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제6조',
      '안전보건교육 실시 및 이수여부 확인\n' +
      '(반기 1회 점검)',
      '현업종사자\n' +
      '- 채용시 교육',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제6조',
      '안전보건교육 실시 및 이수여부 확인\n' +
      '(반기 1회 점검)',
      '현업종사자\n' +
      '- 정기교육(분기6시간)',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제6조',
      '안전보건교육 실시 및 이수여부 확인\n' +
      '(반기 1회 점검)',
      '현업종사자\n' +
      '- 작업내용 변경시 교육',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제6조',
      '안전보건교육 실시 및 이수여부 확인\n' +
      '(반기 1회 점검)',
      '현업종사자\n' +
      '- 특별안전보건교육',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
];
